<template>
    <div class="accommodation">
  
      <div class="title-button">
  
        <h1>Advertise Size</h1>
  
      </div>
      
      <div class="row"> 
        <div class="col-md-6">
          <div class="box">
            <div class="row">
              <div class="col-md-12">
                <form @submit.stop.prevent="doSearch" class="box__header form--inline">
                  <input v-model="quickSearch" type="search" placeholder="Quick search">
                  <button class="button button--small" type="submit">Search</button>
                </form>
                <vdtnet-table
                  ref="table"
                  :fields="fields"
                  :opts="options"
                  @edit="doAlertEdit"
                  @delete="doAlertDelete"
                  >
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <form class="form" v-on:submit.prevent="handleServiceType">
            <div class="box p-3">
              <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="form-label" for="service_name">Advertise Size</label>
                      <input type="text" class="form-control" name="service_name" id="service_name" v-model="advertiseSizeDetail.size_name" placeholder="Advertise Size">
                    </div>
                  </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="form-submit-inline">
                    <button type="submit" class="button"  v-if="userRole == 1">
                      <span> {{ (advertiseSizeDetail.flag == 'add' ? 'Add' : 'Edit') }} Advertise Size </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import 'datatables.net'
  import 'datatables.net-select'
  import VdtnetTable from 'vue-datatables-net'
  
  export default {
    name: 'AdvertiseSizeIndex',
    components: {
      VdtnetTable
    },
    data() {
      return {
        options: {
          ajax: {
            url: this.$api + 'advertise-sizes/table',
            'headers': {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          },
          responsive: false,
          processing: true,
          searching: true,
          searchDelay: 1500,
          destroy: true,
          ordering: true,
          lengthChange: true,
          serverSide: true,
          dom: 'rtlip',
          autoWidth: false,
          lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
          pageLength: 25,
        },
        fields: {
          size_name: { 
            label: 'Size',
          },
          actions: {
            sortable: false,
            label: ' ',
            render: (data, type, row) => {
              return `<a href="/serivce-type/edit/${ row.size_id }" data-action="edit" class="icon icon--more">Edit</a>`
            }
          },
          delete: {
            sortable: false,
            label: ' ',
            className: 'table-action',
            render: (data, type, row) => {
              if (this.userRole == 1) {
                return `<a href="/tour-managers/${ row.size_id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
              } else {
                return ''
              }
            }
          }
        },
        quickSearch: '',
        serviceTypes:[],
        advertiseSizeDetail: {
          flag:'add',
          size_name:null
        },
        userRole: localStorage.getItem("user_role")
      }
    },
    methods: {
      doSearch() {
        this.$refs.table.search(this.quickSearch)
      },
      doAlertEdit(data) {
        this.advertiseSizeDetail = {
          flag: 'edit',
          size_id:data.size_id,
          size_name:data.size_name
        }
      },
      doAlertDelete(data) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'advertise-sizes/' + data.size_id + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.status) {
            this.$refs.table.reload()
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      },
      handleServiceType() {
        this.$store.dispatch('setLoadStatus')
        let formData = new FormData();

        // Iterate through the object
        for (const key in this.advertiseSizeDetail) {
          // Check if the property belongs to the object (not inherited)
          if (this.advertiseSizeDetail.hasOwnProperty(key) && this.advertiseSizeDetail[key]) {
            // Append key-value pair to the FormData object
            formData.append(key, this.advertiseSizeDetail[key]);
          }
        }
        fetch(`${this.$api}advertise-sizes/create`, {
            method: 'POST',
            body: formData,
            headers:{
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
        })
        .then(res => res.json())
        .then(response => {
            this.errors = response.errors
            if(response.status) {
                this.$notify({
                    type: 'success',
                    title: response.message
                });
                this.advertiseSizeDetail = {
                  flag:'add',
                }
                // Reload Table
                this.$refs.table.search(this.quickSearch)
            } else if (response.errors) {
                this.$notify({
                    type: 'error',
                    title: response.message
                });
            }
            this.$store.dispatch('setLoadStatus')
        });
      }
    }
  }
  
  </script>
  